module.exports = __webpack_public_path__ + "static/media/menu.7a2cc739.svg";